import moment from 'moment'
import {WizClassifySelect} from '@/containers/common';
const columns = (api= {}) => {
  return [
    {
      title: "考试名称",
      name: "title",
      dataIndex: "title",
      tableItem: {
        width: 160
      },
      searchItem: { },
    },
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "考试分类",
      name: "categoryTypeIds",
      dataIndex: "categoryTypeIds",
      searchItem: {
        type: 'diy',
        diy: WizClassifySelect,
        returnKey: true,
        wizTreeSelectListProps: {
          checkable: true,
          itemProps: {
            icon: 'unordered-list',
            title: '考试分类',
            tips: '请勾选考试分类'
          },
          treeProps: {checkStrictly: true}
        },
        apiProps: {type: 0},
        selectProps: {
          placeholder: '请选择考试分类'
        },
      },
    },
    {
      title: "考试分类",
      name: "categoryType",
      dataIndex: "categoryType",
      tableItem: {
        width: 100
      },
    },
    {
      title: "考试类型",
      name: "type",
      dataIndex: "type",
      searchItem: {
        type: 'select',
        dict:  [
          { code: 0, codeName: "独立考试" },
          { code: 1, codeName: "课程考试" }
        ],
      }
    },
    {
      title: "考试类型",
      name: "examType",
      dataIndex: "examType",
      tableItem: {
        width: 100,
        render: (text, record) => {
          if(text==='0') {
            return '独立考试'
          } else if (text==='1'){
            return '课程考试'
          } else {
            return '独立考试、课程考试'
          }
        }
      },
    },
    {
      title: "考试时间",
      name: "examDate",
      searchItem: {
        type: 'date~',
        showTime: false,
        format: 'YYYY-MM-DD'
      },
    },
    {
      title: "开始时间",
      name: "startDate",
      dataIndex: "startDate",
      tableItem: {
        width: 220
      },

    },
    {
      title: "结束时间",
      name: "endDate",
      dataIndex: "endDate",
      tableItem: {
        width: 220
      },
    },
    {
      title: "考试状态",
      name: "statusList",
      dataIndex: "status",
      searchItem: {
        type: 'select',
        mode: 'multiple',
        initialValue: api.apiParams?.statusList
      },
      dict: [
        { code: 0, codeName: '草稿' },
        { code: 1, codeName: '已发布' },
        { code: 2, codeName: '已关闭' }
      ],
    },
  ]
}

const tableApi = (api = {}) => {
  return {
    path: 'exam/getListByPage',
    ...api
  }
}

const exam = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    rowkey: 'id',
    rowName: 'title',
    columns: columns(api),
    tableApi: tableApi(api),
    searchProps: {
      dataFormat: (v) => {
        let value = Object.assign([], v)
        if (value['examDate'] && value['examDate'].length === 2) {
          value['startDate'] = moment(value['examDate'][0]).format("YYYY/MM/DD HH:mm:00")
          value['endDate'] = moment(value['examDate'][1]).format("YYYY/MM/DD HH:mm:59")
        }
        delete value['examDate']

        return value
      }
    },
  }
}

export default exam
